export class GlobalComponent {
 
    public static module_name: string = "";

 
}